import { render } from "./TeacherTest.vue?vue&type=template&id=35ad1db0"
import script from "./TeacherTest.vue?vue&type=script&lang=js"
export * from "./TeacherTest.vue?vue&type=script&lang=js"

import exportComponent from "C:\\prathamesh\\mahajyoti_admin_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__